export default "__VITE_ASSET__CYfCA1GN__"